module.exports = __webpack_public_path__ + "static/media/logo.dc355f33.svg";